module.exports = __webpack_public_path__ + "static/kurkar-f19b4ec076e16c9a76d15bd472f5ee1a.jpg";